import {
  analyticsAndTableTransformer,
  analyticsTransformer,
  callsMeetingsTransformer,
  clientsTransformer,
  userKpiTransformer,
} from "./transformResponse/TSRKPITransformer"

import staffListTransformer from "features/shared/api/transformResponse/staffListTransformer"
import parentApi from "store/parentApi"
import { convertQueryObjToString, filterParamsObject } from "utils"

const TSRsKpiApi = parentApi.injectEndpoints({
  endpoints: build => ({
    getTSRStaff: build.query({
      query: ({ userId, ...restParams }) =>
        `/users/reportees/${userId}?hierarchy=true&module=reports&subModule=kpiSupportReport&teamTypeKeys=telesales,support,afn_i_affiliates_client_servicing&${convertQueryObjToString(
          restParams
        )}`,
      transformResponse: response => staffListTransformer(response),
    }),

    getTSRReportAnalytics: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_telesales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: response => analyticsTransformer(response),
      providesTags: ["kpi-reports"],
    }),
    getTSRUserKPI: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_telesales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, req, params) => userKpiTransformer(response, req, params),
      providesTags: ["kpi-reports-user-kpi"],
    }),
    getTSRComparison: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_telesales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, req, params) => analyticsTransformer(response, req, params),
      providesTags: ["kpi-reports-user-kpi"],
    }),
    getTSRClients: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_telesales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: response => clientsTransformer(response),
      providesTags: ["kpi-reports-clients"],
    }),
    getTSRCallsOrMeetings: build.query({
      query: ({ ...params }) =>
        `/reports/v2/kpi_telesales_report?${convertQueryObjToString(
          filterParamsObject(params, "staffType", "aggregated")
        )}`,
      transformResponse: (response, req, params) => callsMeetingsTransformer(response, req, params),
      providesTags: ["kpi-reports-calls-or-meetings"],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetTSRReportAnalyticsQuery,
  useGetTSRUserKPIQuery,
  useGetTSRComparisonQuery,
  useGetTSRClientsQuery,
  useGetTSRCallsOrMeetingsQuery,
  useLazyGetTSRStaffQuery,
  useLazyGetTSRComparisonQuery,
} = TSRsKpiApi
